import React, { useEffect, useState } from "react";
import { Card, Col, Row } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import Breadcrumbs from "../../../shared/components/Breadcrumbs";
import ListView from "../../../shared/components/listview/ListView";
import { TERM_REASON } from "../../../shared/constants/Constants";
import DefaultButton from "../../../shared/components/DefaultButton";
import { CREATENEW } from "../../../shared/constants/Constants";
import Modalpopup from "../../../shared/components/Modalpopup";
import { loadTermReasonDataRequest, loadTermReasonDeleteDataRequest } from "../redux/Actions";
import TermReasonAdd from "./TermReasonAdd";
import TermReasonEdit from "./TermReasonEdit";
import DeleteModal from "../../../shared/components/DeleteModal";
import Permissions from "../../../shared/components/Permissions";

const TermReason = () => {
    let dispatch = useDispatch();
    const [showCreateModal, setShowCreateModal] = useState(false);
    const [showEditModal, setShowEditModal] = useState(false);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    let { termReasons, loading } = useSelector((state) => state.termReason);
    let [selectedRow, setSelectedRow] = useState({})

    let [shouldReload, setShouldReload] = useState(true)

    useEffect(() => {
        if (shouldReload && !loading) {
            setShouldReload(false);
            dispatch(loadTermReasonDataRequest());
        }
    }, [dispatch, loading, shouldReload]);

    let emp_no = JSON.parse(localStorage.getItem("emp_no"));
    let module_name = "Term Reason";
    let permission = Permissions(emp_no, module_name);

    let actionsPermission = !(permission.write_permission || permission.delete_permission);

    let columns = [
        {
            display_name: TERM_REASON,
            field: "term_reason",
            type: "text",
        },
        {
            display_name: "",
            field: 'actions',
            type: 'actions',
            hide: actionsPermission
        }
    ];

    const handleDelete = () => {
        dispatch(loadTermReasonDeleteDataRequest({ id: [selectedRow] }))
        setShouldReload(true)
        setShowDeleteModal(false);
    }
    let [clickEditFunc, setClickEditFunc] = useState(null);
    let [clickDeleteFunc, setClickDeleteFunc] = useState(null);
    useEffect(()=>{
        if (permission.write_permission){
            setClickEditFunc(
                () => (row)=>{
                setSelectedRow(row);
                setShowEditModal(true);
            })
        }
        if (permission.delete_permission){
            setClickDeleteFunc(
                () => (id)=>{
                setSelectedRow(id);
                setShowDeleteModal(true);
            })
        }
    },[permission])

    return (
        <>
            <Row>
                <Col className="gx-0">
                    <Breadcrumbs
                        children={[
                            { label: TERM_REASON },
                        ]}
                    />
                </Col>
                <Col xs="auto" className="gx-0">
                    {permission.create_permission ? (
                        <DefaultButton
                            buttonClass="btn btn-primary default-btn-color"
                            buttonTitle={CREATENEW}
                            actionBlock={() => setShowCreateModal(true)}
                        />
                    ) : ""}
                </Col>
            </Row>
            <Row>
                <Card>
                    <Card.Body>
                        <ListView
                            exportTitle={TERM_REASON}
                            columnNames={columns}
                            rowData={termReasons}
                            clickEdit={clickEditFunc}
                            clickDelete={clickDeleteFunc}
                        />
                    </Card.Body>
                </Card>
            </Row>
            <Modalpopup
                show={showCreateModal}
                handleClose={() => setShowCreateModal(false)}
                actionTitle={"Create " + TERM_REASON}
            >
                <TermReasonAdd
                    handleClose={(reload) => {
                        setShowCreateModal(false);
                        if (reload) {
                            dispatch(loadTermReasonDataRequest());
                        }
                    }}
                />
            </Modalpopup>
            <Modalpopup
                show={showEditModal}
                handleClose={() => { setShowEditModal(false) }}
                actionTitle={"Edit " + TERM_REASON}
            >
                <TermReasonEdit
                    termReason={selectedRow}
                    handleClose={(reload) => {
                        if (reload) {
                            dispatch(loadTermReasonDataRequest());
                        }
                        setShowEditModal(false)
                    }}
                />
            </Modalpopup>
            <DeleteModal
                handleClose={() => { setShowDeleteModal(false) }}
                handleDelete={handleDelete}
                show={showDeleteModal}
            >
                <div>
                    Delete {TERM_REASON}?
                </div>
            </DeleteModal>
        </>
    );
};

export default TermReason;
